import React from "react";
import { MdSearch } from "react-icons/md";

interface LocationAndCartProps {
  onClickLocation: () => void;
  onClickCart: () => void;
  cartLength: number;
  onClickFavorite: () => void;
  onClickExplore: () => void;
}

const LocationAndCart: React.FC<LocationAndCartProps> = ({
  onClickLocation,
  onClickCart,
  cartLength,
  onClickFavorite,
  onClickExplore,
}) => {
  return (
    <div className="py-3 pl-5 bg-white flex items-center cursor-pointer justify-between">
      <div className="flex" onClick={onClickLocation}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <path
            d="M15.4499 14.5749L11.7373 18.2875C11.5749 18.45 11.3821 18.5789 11.1699 18.6669C10.9576 18.7549 10.7302 18.8002 10.5004 18.8002C10.2707 18.8002 10.0432 18.7549 9.83101 18.6669C9.61879 18.5789 9.42599 18.45 9.26363 18.2875L5.55013 14.5749C4.5712 13.5959 3.90455 12.3486 3.63448 10.9907C3.36441 9.63289 3.50306 8.22544 4.03288 6.94638C4.5627 5.66732 5.45991 4.57409 6.61105 3.80493C7.76219 3.03578 9.11555 2.62524 10.5 2.62524C11.8845 2.62524 13.2378 3.03578 14.389 3.80493C15.5401 4.57409 16.4373 5.66732 16.9671 6.94638C17.4969 8.22544 17.6356 9.63289 17.3655 10.9907C17.0955 12.3486 16.4288 13.5959 15.4499 14.5749Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.125 9.625C13.125 10.3212 12.8484 10.9889 12.3562 11.4812C11.8639 11.9734 11.1962 12.25 10.5 12.25C9.80381 12.25 9.13613 11.9734 8.64384 11.4812C8.15156 10.9889 7.875 10.3212 7.875 9.625C7.875 8.92881 8.15156 8.26113 8.64384 7.76884C9.13613 7.27656 9.80381 7 10.5 7C11.1962 7 11.8639 7.27656 12.3562 7.76884C12.8484 8.26113 13.125 8.92881 13.125 9.625Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="ml-1 text-black font-semibold text-md">
          {localStorage.getItem("loadAddr") || "내 위치를 설정해주세요."}
        </span>
      </div>
      <div className="flex items-center">
        <div className="mr-2" onClick={onClickExplore}>
          <MdSearch size={24} color="black" />
        </div>
        <div className="flex items-center mr-2" onClick={onClickFavorite}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 26 25"
            fill="none"
          >
            <path
              d="M4.82315 4.58121C4.38787 5.01648 4.04259 5.53323 3.80702 6.10195C3.57144 6.67067 3.4502 7.28022 3.4502 7.89579C3.4502 8.51137 3.57144 9.12092 3.80702 9.68963C4.04259 10.2584 4.38787 10.7751 4.82315 11.2104L12.8252 19.2125L20.8273 11.2104C21.7064 10.3313 22.2003 9.139 22.2003 7.89579C22.2003 6.65258 21.7064 5.46029 20.8273 4.58121C19.9482 3.70213 18.7559 3.20826 17.5127 3.20826C16.2695 3.20826 15.0772 3.70213 14.1982 4.58121L12.8252 5.95413L11.4523 4.58121C11.017 4.14593 10.5003 3.80064 9.93158 3.56507C9.36286 3.3295 8.75331 3.20825 8.13774 3.20825C7.52216 3.20825 6.91261 3.3295 6.34389 3.56507C5.77518 3.80064 5.25843 4.14593 4.82315 4.58121Z"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="relative inline-block mr-5" onClick={onClickCart}>
          {/* Cart Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M6 6h15l-1.5 9h-13L6 6z"></path>
            <circle cx="9" cy="20" r="1"></circle>
            <circle cx="18" cy="20" r="1"></circle>
            <path d="M6 6L4 2"></path>
          </svg>

          {/* Number Badge */}
          <div className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500 flex items-center justify-center text-white text-xs font-bold">
            {cartLength}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationAndCart;
